/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,
  
} from '@thd-olt-component-react/fusion-utils';







  import { PIPRedirector }
    from "@thd-nucleus/app-render";
  
  export { PIPRedirector }

  import { ProductMetadata }
    from "@thd-olt-component-react/metadata";
  
  export { ProductMetadata }

  import { Breadcrumbs }
    from "@thd-olt-component-react/breadcrumbs";
  
  export { Breadcrumbs }

  import { DynamicRecsWrapperPip }
    from "@thd-olt-component-react/thd-recs-containers";
  
  export { DynamicRecsWrapperPip }

  import { Discontinued }
    from "@thd-olt-component-react/discontinued";
  
  export { Discontinued }

  import { PIPProductDetails }
    from "@thd-olt-component-react/product-details";
  
  export { PIPProductDetails }

  import { MediaGalleryWithHotspotsCarousel }
    from "@thd-olt-component-react/media-gallery";
  
  export { MediaGalleryWithHotspotsCarousel }

  import { PIPSharebelt }
    from "@thd-olt-component-react/thd-sharebelt";
  
  export { PIPSharebelt }

  import { Avataar }
    from "@thd-olt-component-react/augmented-reality";
  
  export { Avataar }

  import { RoomVo }
    from "@thd-olt-component-react/augmented-reality";
  
  export { RoomVo }

  import { ProductPageEventCountdownTimer }
    from "@thd-olt-component-react/event-countdown-timer";
  
  export { ProductPageEventCountdownTimer }

  import { PIPPriceClearanceWrapper }
    from "@thd-olt-component-react/price";
  
  export { PIPPriceClearanceWrapper }

  import { Promotion }
    from "@thd-olt-component-react/promotion";
  
  export { Promotion }

  import { PromotionProductsAnchor }
    from "@thd-olt-component-react/promotion-products";
  
  export { PromotionProductsAnchor }

  import { MeasurementGuideMobile }
    from "@thd-olt-component-react/measurement-guide";
  
  export { MeasurementGuideMobile }

  import { BuyboxWithPIPCalculator }
    from "@thd-olt-component-react/buybox";
  
  export { BuyboxWithPIPCalculator }

  import { BundlePmvFbtLayoutGmAndHdh }
    from "@thd-olt-component-react/bundle-mini";
  
  export { BundlePmvFbtLayoutGmAndHdh }

  import { ProductInfoBar }
    from "@thd-olt-component-react/product-info-bar";
  
  export { ProductInfoBar }

  import { ProductOverviewAccordionTitle }
    from "@thd-olt-component-react/product-overview";
  
  export { ProductOverviewAccordionTitle }

  import { SpecificationsAccordionTitle }
    from "@thd-olt-component-react/specifications";
  
  export { SpecificationsAccordionTitle }

  import { QuestionsAndAnswersAccordionTitle }
    from "@thd-olt-component-react/questions-and-answers";
  
  export { QuestionsAndAnswersAccordionTitle }

  import { RatingsAndReviewsAccordionTitle }
    from "@thd-olt-component-react/ratings-and-reviews";
  
  export { RatingsAndReviewsAccordionTitle }

  import { BazaarVoiceCarousel }
    from "@thd-olt-component-react/social-media-container";
  
  export { BazaarVoiceCarousel }

  import { RoomVoInspire }
    from "@thd-olt-component-react/augmented-reality";
  
  export { RoomVoInspire }

  import { SponsoredPipBanner }
    from "@thd-olt-component-react/sponsored-content";
  
  export { SponsoredPipBanner }

  import { EducationalSummary }
    from "@thd-olt-component-react/educational-summary";
  
  export { EducationalSummary }

  import { RetailMediaCarouselFusionPIP }
    from "@thd-olt-component-react/retail-media-pla-sponsored-placements";
  
  export { RetailMediaCarouselFusionPIP }

  import { RecentlyViewedWrapper }
    from "@thd-olt-component-react/thd-recs-containers";
  
  export { RecentlyViewedWrapper }

  import { TextAnExpert }
    from "@thd-olt-component-react/text-an-expert";
  
  export { TextAnExpert }

  import { HdhomeSignup }
    from "@thd-olt-component-react/email-signup";
  
  export { HdhomeSignup }

  import { RelatedSearch }
    from "@thd-olt-component-react/related-search";
  
  export { RelatedSearch }

  import { RelatedProducts }
    from "@thd-olt-component-react/related-search";
  
  export { RelatedProducts }

  import { PopularVariations }
    from "@thd-olt-component-react/related-search";
  
  export { PopularVariations }

  import { EmtLinks }
    from "@thd-olt-component-react/emt-links";
  
  export { EmtLinks }






import { AugmentedReality as AugmentedRealitySSR } from '@thd-olt-component-react/augmented-reality?clientSideRemove';

import { ConsumerCardMessaging as ConsumerCardMessagingSSR } from '@thd-olt-component-react/consumer-card-messaging?clientSideRemove';

import { AisleBay as AisleBaySSR } from '@thd-olt-component-react/aisle-bay?clientSideRemove';

import { SuperSku as SuperSkuSSR } from '@thd-olt-component-react/super-sku?clientSideRemove';

import { OrderSample as OrderSampleSSR } from '@thd-olt-component-react/order-sample?clientSideRemove';

import { GlobalCustomConfigurator as GlobalCustomConfiguratorSSR } from '@thd-olt-component-react/global-custom-configurator?clientSideRemove';

import { ReturnsMessaging as ReturnsMessagingSSR } from '@thd-olt-component-react/returns-messaging?clientSideRemove';

import { BotPrompt as BotPromptSSR } from '@thd-olt-component-react/magic-apron?clientSideRemove';

import { ProductOverviewAccordionTitle as ProductOverviewAccordionTitleSSR } from '@thd-olt-component-react/product-overview?clientSideRemove';

import { SpecificationsAccordionTitle as SpecificationsAccordionTitleSSR } from '@thd-olt-component-react/specifications?clientSideRemove';

import { QuestionsAndAnswersAccordionTitle as QuestionsAndAnswersAccordionTitleSSR } from '@thd-olt-component-react/questions-and-answers?clientSideRemove';

import { RatingsAndReviewsAccordionTitle as RatingsAndReviewsAccordionTitleSSR } from '@thd-olt-component-react/ratings-and-reviews?clientSideRemove';

import { ProductOverviewAccordionBody as ProductOverviewAccordionBodySSR } from '@thd-olt-component-react/product-overview?clientSideRemove';

import { SpecificationsWithKPFAccordionBody as SpecificationsWithKPFAccordionBodySSR } from '@thd-olt-component-react/specifications?clientSideRemove';

import { QuestionsAndAnswersAccordionBody as QuestionsAndAnswersAccordionBodySSR } from '@thd-olt-component-react/questions-and-answers?clientSideRemove';

import { RatingsAndReviewsAccordionBody as RatingsAndReviewsAccordionBodySSR } from '@thd-olt-component-react/ratings-and-reviews?clientSideRemove';



  
    
      
        const SlotA1 = withLayout(
          [
            
              PIPRedirector,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotA2 = withLayout(
          [
            
              ProductMetadata,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotB1 = withLayout(
          [
            
              Breadcrumbs,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotC1 = withLayout(
          [
            
              Breadcrumbs,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotC2 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotC3 = withLayout(
          [
            
              Discontinued,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotD1 = withLayout(
          [
            
              PIPProductDetails,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotD2 = withLayout(
          [
            
              MediaGalleryWithHotspotsCarousel,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotD3 = withLayout(
          [
            
              PIPSharebelt,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotD4 = withLayout(
          [
            
              Avataar,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotD5 = withLayout(
          [
            
              RoomVo,
            
          ],
          
        );
      
    
  

  

  
    
      
        const SlotE1 = withLayout(
          [
            
              ProductPageEventCountdownTimer,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotE2 = withLayout(
          [
            
              PIPPriceClearanceWrapper,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotE3 = withLayout(
          [
            
              Promotion,
            
          ],
          
        );
      
    
  

  

  
    
      
        const SlotE5 = withLayout(
          [
            
              PromotionProductsAnchor,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotE6 = withLayout(
          [
            
              MeasurementGuideMobile,
            
          ],
          
        );
      
    
  

  

  

  

  

  
    
      
        const SlotE11 = withLayout(
          [
            
              BuyboxWithPIPCalculator,
            
          ],
          
        );
      
    
  

  

  
    
      
        const SlotF1 = withLayout(
          [
            
              BundlePmvFbtLayoutGmAndHdh,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF2 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF3 = withLayout(
          [
            
              ProductInfoBar,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF4 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  

  

  

  
    
      
        const SlotF8 = withLayout(
          [
            
              BazaarVoiceCarousel,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF9 = withLayout(
          [
            
              RoomVoInspire,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF10 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF11 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF12 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF13 = withLayout(
          [
            
              SponsoredPipBanner,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF14 = withLayout(
          [
            
              EducationalSummary,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF15 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF16 = withLayout(
          [
            
              RetailMediaCarouselFusionPIP,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF17 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF18 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF19 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF20 = withLayout(
          [
            
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF21 = withLayout(
          [
            
              RecentlyViewedWrapper,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF22 = withLayout(
          [
            
              TextAnExpert,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF23 = withLayout(
          [
            
              HdhomeSignup,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF24 = withLayout(
          [
            
              RelatedSearch,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF25 = withLayout(
          [
            
              RelatedProducts,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF26 = withLayout(
          [
            
              PopularVariations,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF27 = withLayout(
          [
            
              EmtLinks,
            
          ],
          
        );
      
    
  



const ssr = typeof window === 'undefined';


  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  
    


    
      
        const SlotD6Index0DataModel = ssr
        ? AugmentedRealitySSR
        : {};

      
    
  

  
  

  
  

  
  

  
  
    


    
      
        const SlotE4Index0DataModel = ssr
        ? ConsumerCardMessagingSSR
        : {};

      
    
  

  
  

  
  

  
  
    


    
      
        const SlotE7Index0DataModel = ssr
        ? AisleBaySSR
        : {};

      
    
  

  
  
    


    
      
        const SlotE8Index0DataModel = ssr
        ? SuperSkuSSR
        : {};

      
    
  

  
  
    


    
      
        const SlotE9Index0DataModel = ssr
        ? OrderSampleSSR
        : {};

      
    
  

  
  
    


    
      
        const SlotE10Index0DataModel = ssr
        ? GlobalCustomConfiguratorSSR
        : {};

      
    
  

  
  

  
  
    


    
      
        const SlotE12Index0DataModel = ssr
        ? ReturnsMessagingSSR
        : {};

      
    
  

  
  

  
  

  
  

  
  

  
  
    


    
      
        const SlotF5Index0DataModel = ssr
        ? BotPromptSSR
        : {};

      
    
  

  
  
    
      
      
        
          const SlotF6Index0DataModelK0 = ssr
          ? ProductOverviewAccordionTitleSSR
          : {};
        
        
        
          const SlotF6Index0DataModelBodyK0 = ssr
          ? ProductOverviewAccordionBodySSR
          : {};
        
      
        
          const SlotF6Index1DataModelK0 = ssr
          ? SpecificationsAccordionTitleSSR
          : {};
        
        
        
          const SlotF6Index1DataModelBodyK0 = ssr
          ? SpecificationsWithKPFAccordionBodySSR
          : {};
        
      
        
          const SlotF6Index2DataModelK0 = ssr
          ? QuestionsAndAnswersAccordionTitleSSR
          : {};
        
        
        
          const SlotF6Index2DataModelBodyK0 = ssr
          ? QuestionsAndAnswersAccordionBodySSR
          : {};
        
      
        
          const SlotF6Index3DataModelK0 = ssr
          ? RatingsAndReviewsAccordionTitleSSR
          : {};
        
        
        
          const SlotF6Index3DataModelBodyK0 = ssr
          ? RatingsAndReviewsAccordionBodySSR
          : {};
        
      
    


    
  

  
  
    


    
      
        const SlotF7Index0DataModel = ssr
        ? BotPromptSSR
        : {};

      
    
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  



export {
  
  
    
      SlotA1,
    
  
    
      SlotA2,
    
  
    
      SlotB1,
    
  
    
      SlotC1,
    
  
    
      SlotC2,
    
  
    
      SlotC3,
    
  
    
      SlotD1,
    
  
    
      SlotD2,
    
  
    
      SlotD3,
    
  
    
      SlotD4,
    
  
    
      SlotD5,
    
  
    
  
    
      SlotE1,
    
  
    
      SlotE2,
    
  
    
      SlotE3,
    
  
    
  
    
      SlotE5,
    
  
    
      SlotE6,
    
  
    
  
    
  
    
  
    
  
    
      SlotE11,
    
  
    
  
    
      SlotF1,
    
  
    
      SlotF2,
    
  
    
      SlotF3,
    
  
    
      SlotF4,
    
  
    
  
    
  
    
  
    
      SlotF8,
    
  
    
      SlotF9,
    
  
    
      SlotF10,
    
  
    
      SlotF11,
    
  
    
      SlotF12,
    
  
    
      SlotF13,
    
  
    
      SlotF14,
    
  
    
      SlotF15,
    
  
    
      SlotF16,
    
  
    
      SlotF17,
    
  
    
      SlotF18,
    
  
    
      SlotF19,
    
  
    
      SlotF20,
    
  
    
      SlotF21,
    
  
    
      SlotF22,
    
  
    
      SlotF23,
    
  
    
      SlotF24,
    
  
    
      SlotF25,
    
  
    
      SlotF26,
    
  
    
      SlotF27,
    
  

  
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
      
      

      
        
          SlotD6Index0DataModel,
        
      
    
  
    
  
    
  
    
  
    
      
      

      
        
          SlotE4Index0DataModel,
        
      
    
  
    
  
    
  
    
      
      

      
        
          SlotE7Index0DataModel,
        
      
    
  
    
      
      

      
        
          SlotE8Index0DataModel,
        
      
    
  
    
      
      

      
        
          SlotE9Index0DataModel,
        
      
    
  
    
      
      

      
        
          SlotE10Index0DataModel,
        
      
    
  
    
  
    
      
      

      
        
          SlotE12Index0DataModel,
        
      
    
  
    
  
    
  
    
  
    
  
    
      
      

      
        
          SlotF5Index0DataModel,
        
      
    
  
    
      
      
        
          
          
            SlotF6Index0DataModelK0,
          
          
          
            SlotF6Index0DataModelBodyK0,
          
        
          
          
            SlotF6Index1DataModelK0,
          
          
          
            SlotF6Index1DataModelBodyK0,
          
        
          
          
            SlotF6Index2DataModelK0,
          
          
          
            SlotF6Index2DataModelBodyK0,
          
        
          
          
            SlotF6Index3DataModelK0,
          
          
          
            SlotF6Index3DataModelBodyK0,
          
        
      

      
    
  
    
      
      

      
        
          SlotF7Index0DataModel,
        
      
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  

};